import * as THREE from "three";

const URLS = {
  moon: "https://raw.githubusercontent.com/mrdoob/three.js/r169/examples/textures/planets/moon_1024.jpg",
  earthDay: "https://unpkg.com/three-globe@2.45.2/example/img/earth-blue-marble.jpg",
  earthNight: "https://unpkg.com/three-globe@2.45.2/example/img/earth-night.jpg",
};

// ---- procedural fallbacks (canvas) --------------------------------------
function proceduralMoon() {
  const c = document.createElement("canvas");
  c.width = 1024; c.height = 512;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#8f8d88"; ctx.fillRect(0, 0, 1024, 512);
  // maria (dark basalt plains)
  for (let i = 0; i < 14; i++) {
    ctx.beginPath();
    ctx.fillStyle = `rgba(70,70,74,${0.25 + Math.random() * 0.3})`;
    ctx.arc(Math.random() * 1024, Math.random() * 512, 40 + Math.random() * 90, 0, Math.PI * 2);
    ctx.fill();
  }
  // craters
  for (let i = 0; i < 320; i++) {
    const x = Math.random() * 1024, y = Math.random() * 512, r = 3 + Math.random() * 22;
    ctx.beginPath();
    ctx.fillStyle = `rgba(60,58,56,${0.4 + Math.random() * 0.4})`;
    ctx.arc(x, y, r, 0, Math.PI * 2); ctx.fill();
    ctx.beginPath();
    ctx.strokeStyle = `rgba(200,198,192,${0.3 + Math.random() * 0.4})`;
    ctx.lineWidth = 1 + Math.random() * 1.5;
    ctx.arc(x - r * 0.2, y - r * 0.2, r * 0.9, 0, Math.PI * 2); ctx.stroke();
  }
  // Tycho-style bright ray crater
  ctx.beginPath(); ctx.fillStyle = "rgba(230,228,222,0.9)";
  ctx.arc(560, 400, 16, 0, Math.PI * 2); ctx.fill();
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t;
}
function proceduralEarthDay() {
  const c = document.createElement("canvas"); c.width = 1024; c.height = 512;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#0d2a55"; ctx.fillRect(0, 0, 1024, 512);
  for (let i = 0; i < 40; i++) {
    ctx.beginPath();
    ctx.fillStyle = `rgba(${30 + Math.random() * 40},${90 + Math.random() * 60},${40 + Math.random() * 30},0.9)`;
    ctx.ellipse(Math.random() * 1024, Math.random() * 512, 30 + Math.random() * 80, 20 + Math.random() * 50, Math.random() * 3, 0, Math.PI * 2);
    ctx.fill();
  }
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t;
}
function proceduralEarthNight() {
  const c = document.createElement("canvas"); c.width = 1024; c.height = 512;
  const ctx = c.getContext("2d");
  ctx.fillStyle = "#04060c"; ctx.fillRect(0, 0, 1024, 512);
  for (let i = 0; i < 900; i++) {
    ctx.fillStyle = `rgba(255,${190 + Math.random() * 50},${120 + Math.random() * 60},${0.5 + Math.random() * 0.5})`;
    ctx.fillRect(Math.random() * 1024, Math.random() * 512, 1.5, 1.5);
  }
  const t = new THREE.CanvasTexture(c); t.colorSpace = THREE.SRGBColorSpace; return t;
}

export const textures = { moon: null, earthDay: null, earthNight: null, ready: false };

function loadOne(url, fallback) {
  return new Promise((resolve) => {
    const loader = new THREE.TextureLoader();
    loader.setCrossOrigin("anonymous");
    const timer = setTimeout(() => resolve(fallback()), 9000);
    loader.load(
      url,
      (t) => { clearTimeout(timer); t.colorSpace = THREE.SRGBColorSpace; t.anisotropy = 16; t.generateMipmaps = true; resolve(t); },
      undefined,
      () => { clearTimeout(timer); resolve(fallback()); }
    );
  });
}

let _promise = null;
export function preloadTextures() {
  if (_promise) return _promise;
  _promise = Promise.all([
    loadOne(URLS.moon, proceduralMoon),
    loadOne(URLS.earthDay, proceduralEarthDay),
    loadOne(URLS.earthNight, proceduralEarthNight),
  ]).then(([moon, earthDay, earthNight]) => {
    textures.moon = moon;
    textures.earthDay = earthDay;
    textures.earthNight = earthNight;
    textures.ready = true;
    return textures;
  });
  return _promise;
}
